<template>

    <div :class="{ 'text-muted': !hasValue }" :inner-html.prop="displayValue" />

</template>

<script>

export default {

    props: {
        value: {
            type: [String, Number, Boolean],
            default: null,
        },
    },

    computed: {

        hasValue() {
            return this.value !== null;
        },

        displayValue() {
            return this.hasValue ? this.value : 'Unknown';
        },

    },

}

</script>
